import { Avatar, Stack, Link, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { stringAvatar } from '@/utils';
import { HeaderDialogsEnum, UserModel } from '@/types';

const UserName = styled(Typography)({
  fontSize: '16px',
  fontWeight: '600',
  color: '#1650FF',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  '&:hover': {
    textDecoration: 'underline',
  },
});

interface IContactBlockProps {
  user: {
    name: string | undefined;
    id: string | undefined;
    avatar: string | null | undefined;
  };
  userMe?: UserModel;
  isTariffFree?: boolean;
  handleClickOpenDialog?: (value: HeaderDialogsEnum) => void;
}

export const ContactBlock: React.FC<IContactBlockProps> = ({
  user,
  userMe,
  isTariffFree,
  handleClickOpenDialog,
}) => {
  const isCheckedMy = userMe?.id === user.id;
  const userName = isTariffFree ? 'Creator of request' : user?.name;
  const requestCreatorHref = isCheckedMy ? '/profile/view' : `/users/${user.id}`;

  return (
    <Stack
      alignItems='flex-start'
      spacing={1}
      sx={{
        flex: '1 1 auto',
        width: 'auto',
        maxWidth: '100%',
        minWidth: 0,
        filter: isTariffFree ? 'blur(5px)' : 'blur(0px)',
      }}
    >
      <Link
        href={isTariffFree ? undefined : requestCreatorHref}
        title={user.name}
        style={{
          color: '#2A3842',
          display: 'block',
          maxWidth: '100%',
          minWidth: 0,
          overflow: 'hidden',
          textDecoration: 'none',
          width: '100%',
        }}
        onClick={() => isTariffFree && handleClickOpenDialog?.(HeaderDialogsEnum.Tariff)}
      >
        <Stack
          direction='row'
          alignItems='center'
          spacing={1}
          style={{ minWidth: 0, position: 'relative' }}
        >
          <Avatar
            src={user.avatar ? user.avatar : ''}
            {...stringAvatar(user.name)}
            sx={{ width: 24, height: 24, flexShrink: 0, fontSize: 12 }}
          />
          <UserName sx={{ minWidth: 0 }}>{userName}</UserName>
        </Stack>
      </Link>
    </Stack>
  );
};
